import { useState } from 'react';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    innerWidth: 0,
    innerHeight: 0,
  });

  const handleWindowSizeChange = () => {
    const { innerWidth, innerHeight } = window;
    setWindowSize({ innerWidth, innerHeight });
  };

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    // Unmount
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  // initialize state on client side
  useIsomorphicLayoutEffect(() => {
    handleWindowSizeChange();
  }, []);

  return windowSize;
};
